import axios from "axios";
import Cookies from "js-cookie";

const ACTIVITY_CODE = "school_activity_2026";

// 每次请求时动态获取，避免模块加载时只取一次
function getHeaders() {
    return {
        token: Cookies.get("wx_token"),
    };
}

function getBaseData() {
    return {
        userId: Cookies.get("wx_userId"),
        platForm: "web",
    };
}

// 通用请求方法，自动合并公共参数
function post(url, data = {}) {
    return axios({
        url,
        method: "post",
        headers: getHeaders(),
        data: {
            ...getBaseData(),
            activityCode: ACTIVITY_CODE,
            ...data,
        },
    });
}

// ========== 接口 ==========

// 获取用户信息
export function getMemberInfoApi() {
    return axios({
        url: "/user/getMemberInfo",
        method: "post",
        headers: getHeaders(),
        data: getBaseData(),
    });
}

// 获取连线活动、盘面、线路及保底状态
export function getInfoApi(data) {
    return post("/lineActivity/getInfo", data);
}

// 点亮一次
export function lightOnceApi(data) {
    return post("/lineActivity/lightOnce", data);
}

// 点亮十次，服务端逐次结算
export function lightTenApi(data) {
    return post("/lineActivity/lightTen", data);
}

// 补签并领取当日奖励
export function makeupSignApi(data) {
    return post("/lineActivity/makeupSign", data);
}

// 当天签到并领取奖励
export function signApi(data) {
    return post("/lineActivity/sign", data);
}

// 兑换商店购买
export function exchangeShopApi(data) {
    return post("/lineActivity/exchangeShop", data);
}

// 使用S级兑换券兑换道具（全服共享库存）
export function exchangeVoucherApi(data) {
    return post("/lineActivity/exchangeVoucher", data);
}

// 当前账号S券兑换记录
export function voucherExchangeRecordsApi(data) {
    return post("/lineActivity/voucherExchangeRecords", data);
}

// 手动领取一条已激活线路的奖励
export function claimLineRewardApi(data) {
    return post("/lineActivity/claimLineReward", data);
}

// 当前账号抽奖记录（每抽一条，活动结束后仍可查看）
export function drawRecordsApi(data) {
    return post("/lineActivity/drawRecords", data);
}
